import { useTrans } from '@/shared/hooks/useTranslation';
import type { FallbackProps } from '@/view/shared/Fallback/Fallback.props';
import { Alert, Button } from '@heroui/react';
import { RotateCw } from 'lucide-react';

export const Fallback = ({ message }: FallbackProps) => {
  const { t } = useTrans();
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md mx-4">
        <Alert status="danger" className="mb-4">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Description>{message || t('common.error.unexpected')}</Alert.Description>
          </Alert.Content>
        </Alert>
        <Button variant="danger" className="w-full" onPress={() => globalThis.location.reload()}>
          <RotateCw className="w-5 h-5" />
          {t('common.actions.reload')}
        </Button>
      </div>
    </div>
  );
};
